export default "__VITE_ASSET__94864ea8__"